import { FC } from 'react';

import {
  type CombinedFeatureTypes,
  FeatureTypeNonFeatureSliceEnum,
  FeatureTypeSelectionsPanelEnum,
} from '../selectionsPanel/constants';
import { BoundaryCard } from './selectionsPanelContent/cardContent/boundaryCard';
import CustomizationCard from './selectionsPanelContent/cardContent/customizationCard';
import { DeedPlotterCard } from './selectionsPanelContent/cardContent/deedPlotterCard';
import { DefaultCard } from './selectionsPanelContent/cardContent/defaultCard';
import { ListingCard } from './selectionsPanelContent/cardContent/listingCard';
import { ParcelCard } from './selectionsPanelContent/cardContent/parcelCard';
import { SavedCard } from './selectionsPanelContent/cardContent/savedCard';
import { SoldLandCard } from './selectionsPanelContent/cardContent/soldLandCard';
import { UploadCard } from './selectionsPanelContent/cardContent/uploadCard';

export const featureTypeContent: Record<CombinedFeatureTypes, FC> = {
  [FeatureTypeSelectionsPanelEnum.PARCEL]: ParcelCard,
  [FeatureTypeSelectionsPanelEnum.FSA]: DefaultCard,
  [FeatureTypeSelectionsPanelEnum.COMP]: SoldLandCard,
  [FeatureTypeSelectionsPanelEnum.SAVED]: SavedCard,
  [FeatureTypeSelectionsPanelEnum.REAL_ESTATE]: ListingCard,
  [FeatureTypeSelectionsPanelEnum.UPLOAD]: UploadCard,
  [FeatureTypeSelectionsPanelEnum.CLAIMED]: SavedCard,
  [FeatureTypeNonFeatureSliceEnum.CUSTOMIZATIONS]: CustomizationCard,
  [FeatureTypeSelectionsPanelEnum.BOUNDARY]: BoundaryCard,
  [FeatureTypeNonFeatureSliceEnum.DEED_PLOTTER]: DeedPlotterCard,
};
